import {
  LOGIN,
  SIGNUP,
  LOGIN_REQUEST,
  SIGNUP_REQUEST,
  SIGNUP_FAILURE,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT,
  LOGOUT_FAILURE,
} from "../actions/auth";

const initialState = {
  token: null,
  userId: null,
  email: null,
  authenticate: false,
  authenticating: false,
  loading: false,
  errorRes: null,
  message: "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        authenticating: true,
      };
    case SIGNUP_REQUEST:
      return {
        ...state,
        authenticating: true,
      };
    case LOGIN:
      return {
        ...state,
        userId: action.userId,
        token: action.token,
        email: action.email,
        authenticate: true,
        authenticating: false,
      };
    case SIGNUP:
      return {
        ...state,
        userId: action.userId,
        token: action.token,
        email: action.email,
        authenticate: true,
        authenticating: false,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        authenticate: false,
        authenticating: false,
        errorRes: action.errorRes,
        message: "Login failed",
      };
    case SIGNUP_FAILURE:
      return {
        ...state,
        authenticate: false,
        authenticating: false,
        errorRes: action.errorRes,
        message: "Sign up failed",
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        errorRes: action.errorRes,
        loading: false,
        message: "Logout failed",
      };
    default:
      return state;
  }
};

export default authReducer;
